export default "__VITE_ASSET__BbDYxEL0__"